
import { ResourceFile } from "./types";
import { SidebarFileItemList } from "./SidebarFileItemList";
import PDFSidebarActions from "./PDFSidebarActions";
import { DownloadButton } from "./sidebar/DownloadButton";

interface SidebarFileListProps {
  files: ResourceFile[];
  completedFiles: { [key: string]: boolean };
  currentFileIndex: number;
  handleFileChange: (index: number) => void;
  isTrainee: boolean;
  isAdmin: boolean;
  isFileLocked: (index: number) => boolean;
  overallProgress: number;
  completedAt: string | null;
  resourceId: string;
  topic?: string;
  company?: string;
}

export function SidebarFileList({
  files,
  completedFiles,
  currentFileIndex,
  handleFileChange,
  isTrainee,
  isAdmin,
  isFileLocked,
  overallProgress,
  completedAt,
  resourceId,
  topic = "Training",
  company = "Company"
}: SidebarFileListProps) {
  
  console.log("SidebarFileList rendering", { isAdmin, isTrainee, resourceId });
  
  return (
    <div className="w-[280px] flex-shrink-0 border-r border-border h-full flex flex-col bg-muted/30">
      <div className="flex flex-col h-full overflow-hidden">
        <div className="flex-1 overflow-auto">
          <div className="p-4 border-b border-muted">
            <h2 className="text-lg font-semibold">{topic}</h2>
            <p className="text-sm text-muted-foreground">{company}</p>
          </div>
          
          <SidebarFileItemList
            files={files}
            completedFiles={completedFiles}
            currentFileIndex={currentFileIndex}
            isTrainee={isTrainee}
            isAdmin={isAdmin}
            handleFileChange={handleFileChange}
            isFileLocked={isFileLocked}
          />
        </div>

        {/* Pass only the props that PDFSidebarActions expects */}
        <div className="mt-auto">
          {files.length > 0 && (
            <PDFSidebarActions
              file={files[currentFileIndex]}
              resourceId={resourceId}
              currentFile={files[currentFileIndex]}
              topic={topic}
              company={company}
            />
          )}
        </div>
        
        {isAdmin && (
          <DownloadButton 
            resourceId={resourceId} 
            topic={topic}
            company={company}
          />
        )}
      </div>
    </div>
  );
}
